<template>
  <h1 class="bg-gradient-to-r from-white to-purple-200 bg-clip-text text-[1.5rem] font-bold text-transparent pb-2 leading-[1]">
    <slot />
  </h1>
</template>

<script lang="ts" setup>
</script>